/**
 * 画布多指手势共享态：三指平移期间（及两指以上候选阶段）抑制选段 / 底栏等 UI 操作。
 */
type TtqCanvasGestureState = {
  activePointers: number;
  multiPanActive: boolean;
  /** 多指手势刚结束：短时继续吞掉 click，避免抬指误触选段 */
  suppressClickUntil: number;
};

const state: TtqCanvasGestureState = {
  activePointers: 0,
  multiPanActive: false,
  suppressClickUntil: 0,
};

const CLICK_SUPPRESS_MS = 450;

export const ttqCanvasGesture = {
  get activePointers() {
    return state.activePointers;
  },
  setActivePointers(count: number) {
    state.activePointers = Math.max(0, count);
    if (state.activePointers === 0) {
      if (state.multiPanActive) {
        state.suppressClickUntil = Date.now() + CLICK_SUPPRESS_MS;
      }
      state.multiPanActive = false;
    }
  },
  setMultiPanActive(active: boolean) {
    if (active) {
      state.multiPanActive = true;
      state.suppressClickUntil = Date.now() + CLICK_SUPPRESS_MS;
      return;
    }
    if (state.multiPanActive) {
      state.suppressClickUntil = Date.now() + CLICK_SUPPRESS_MS;
    }
    state.multiPanActive = false;
  },
  /** 两指及以上或已进入三指平移：禁止选段、品题底栏等 */
  isSuppressingUi() {
    return state.multiPanActive || state.activePointers >= 2;
  },
  /** 含抬指后的短冷却，用于吞掉残余 click */
  shouldBlockClick() {
    return this.isSuppressingUi() || Date.now() < state.suppressClickUntil;
  },
};
